import './styles/globals.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { AuthProvider } from './contexts/AuthContext';
import { RegionalSettingsProvider } from './contexts/RegionalSettingsContext';
import { loadRuntimeConfig } from './runtimeConfig';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

document.documentElement.classList.remove('dark');

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElementNode = document.getElementById('root');
const root = createRoot(rootElementNode);

const bootstrap = async () => {
  await loadRuntimeConfig();
  const { default: App } = await import('./App');

  root.render(
    <BrowserRouter basename={baseUrl}>
      <AuthProvider>
        <RegionalSettingsProvider>
          <App />
        </RegionalSettingsProvider>
      </AuthProvider>
    </BrowserRouter>);

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.unregister();

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};

void bootstrap();
